<template>
  <!-- 修改邮箱弹窗 -->
  <custom-dialog :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item :label="$t('c_email1_you_xiang')" prop="email">
          <el-input v-model="form.email" :placeholder="$t('c_email1_qsryxdz')" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="confirm">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// c_email1_you_xiang: 邮箱// c_email1_qsryxdz: 请输入邮箱地址// c_email1_qsryxdz_1: 请输入邮箱地址

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        email: '',
      },
      userInfo: {},
    };
  },
  computed: {
    rules() {
      return {
        email: [{ required: true, message: this.$t('c_email1_qsryxdz_1') }],
      };
    }
  },
  mounted() {
    this.mergeLanguage(null, 'portal_change_email_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.userInfo = this.model.row;
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.row || {});
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserEmail, { email: this.form.email }, true)
          .then(() => {
            this.visible = false;
            this.userInfo.email = this.form.email;
            this.$store.commit('USERINFO', this.userInfo);
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success',
            });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
